<template>
  <!-- <div class="wechatCommonNav" v-show="isShowNav"> -->
    <el-drawer
  title="我是标题"
  :visible.sync="shortcutVisible"
  @close="closeDrawer"
  :with-header="false"
  class="wechatCommonNav"
  size="50%"
  :direction="'ltr'">
    <p class="wechatUserLogin">
      <el-icon class="el-icon-user-solid"/>
      <span v-if="!userName" @click="signIn"> 用户登录</span>
      <span v-else> {{ userName }},<span @click="signOut">登出</span></span>
    </p>
    <ul class="wechatNavUl">
      <li @click="toPage('apps')"><a-icon type="home" />首页</li>
    <li @click="toPageService(true)"><a-icon type="container" />服务中心</li>
    <li @click="toPageService(true, 'todo')"><a-icon type="user" />我的事务</li>
    <li @click="toPageService(false)" v-if="!userName">
      <a-icon type="eye" />
      访客浏览</li>
    </ul>

  <!-- </div> -->
    </el-drawer>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";

export default {
  name: "commonNav",
  computed:{
    userName() {
      return this.$store.getters.getUserInfo.name;
    },
    ...mapState(['shortcutVisible']),
  },
  inject: ['isPage', 'reload'],
  methods:{
    ...mapActions("oidcStore", ['signOutOidc']),
    closeDrawer(){
      this.$store.commit('setShortcutVisible', false);
    },
    toPageService(bool, name) {
      sessionStorage.setItem('hasSigned', bool);
      this.toPage(name || 'serviceC')
    },
    toPage(name){
      if(!this.isPage(name)){
        if(name === 'serviceC'){
        sessionStorage.removeItem('targetNow')
      }
      this.$router.push({"name": name});
      }
      this.$store.commit('setShortcutVisible', false);
      
    },
    signIn(){
      sessionStorage.setItem('hasSigned', true)
      this.$router.push('/workflow/home');
    },
    signOut(){
      sessionStorage.removeItem('hasSigned')
      this.signOutOidc()
    }
  }
}
</script>

<style lang="less" scoped>
.wechatCommonNav{
  .wechatUserLogin {
    color: #337ab7;
    text-align: center;
    margin-top: 30vh;
  }

  .wechatNavUl {
    margin-top: 10px;
    li{
      padding-left: 48px;
      margin-bottom: 12px;
      display: flex;
      align-items: center;

      i{
        font-size: 12px;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/views/todoCenter/default/wechat/layout/commonNav.vue